import React from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import Loader from './Loader';

function AppLoading({ isLoading }) {
  return (
    <Modal
      centered
      show={isLoading}
      size="sm"
      backdrop="static"
      keyboard={false}
      dialogClassName="modal-90w d-flex justify-content-center app-loading"
      aria-labelledby="API request going. Waiting for response"
    >
      <Modal.Body className="p-0">
        <div className="d-flex flex-column align-items-center justify-content-center">
          {/* <span
            className="fs-16 fs-400"
            style={{ fontWeight: '300', color: '#fff' }}
          >
            <FormattedMessage id="please_wait" />
          </span> */}
          {/* <img
            style={{ width: '100px' }}
            src="/images/loader.gif"
            alt="Please wait"
          /> */}
          <Loader size={100} />
          {/* <span
            className="fs-14 fs-400"
            style={{ fontWeight: '300', color: '#fff' }}
          >
            <FormattedMessage id="loading" />
          </span> */}
        </div>
      </Modal.Body>
    </Modal>
  );
}

AppLoading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

export default AppLoading;
